/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Home: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="home" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M757.095 1140.8274999999999L1234.5825 697.4675L1183.1575 642.09L1057.74 758.5400000000001V302.2175C1057.74 239.615 1006.995 188.8700000000001 944.3924999999998 188.8700000000001H302.1749999999999V758.4975000000002L176.7574999999998 642.0475000000001L125.3324999999998 697.4250000000002L602.8199999999997 1140.785C646.2974999999997 1181.16 713.5749999999997 1181.16 757.0524999999998 1140.785zM705.7125 1085.45C691.22 1098.9225000000001 668.78 1098.9225000000001 654.2875 1085.45L377.7825 828.6650000000001V264.435H944.435C965.3025 264.435 982.2175 281.3500000000002 982.2175 302.2175V828.7075L705.7125 1085.4925z" : "M605.676 912.662L987.666 557.9739999999999L946.526 513.672L846.1919999999999 606.8320000000001V241.774C846.1919999999999 191.692 805.596 151.0960000000001 755.5139999999999 151.0960000000001H241.7399999999999V606.7980000000001L141.4059999999998 513.6380000000001L100.2659999999999 557.9400000000002L482.2559999999998 912.6280000000002C517.0379999999998 944.9280000000002 570.8599999999997 944.9280000000002 605.6419999999998 912.6280000000002zM564.57 868.36C552.976 879.138 535.024 879.138 523.43 868.36L302.226 662.932V211.548H755.548C772.2420000000001 211.548 785.774 225.0800000000001 785.774 241.774V662.966L564.57 868.394z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Home.displayName = `Blueprint5.Icon.Home`;
export default Home;
